module.exports = __webpack_public_path__ + "img/msgError.eabad4f1.png";